export default "__VITE_ASSET__Q_8vqt$x__"